import React from 'react';
import SentimentControls from './SentimentControls';

const PivotLabelControls = ({
  selectedRowLabel,
  setSelectedRowLabel,
  selectedColLabel,
  setSelectedColLabel,
  selectedFirstLabel,
  setSelectedFirstLabel,
  selectedSecondLabel,
  setSelectedSecondLabel,
  labelTypes,
  labels,
  isSentimentEnabled,
  rowSentimentStates,
  colSentimentStates,
  handleRowSentimentChange,
  handleColSentimentChange,
  setSortBy,
  handleResetCrossLabelAnalysis,
}) => {
  return (
    <div className="labels-tab">
        {/* Label Selection Row */}
        <div className="pivot-label-selection">
            <div className="pivot-label-select">
            <label>
                Labels to display in the rows :
                <select value={selectedRowLabel} onChange={(e) => setSelectedRowLabel(e.target.value)}>
                    {Object.keys(labelTypes)
                        .map((labelType) => (<option key={labelType} value={labelType}>{labelType}</option>))
                        .sort((a, b) => a.props.children.localeCompare(b.props.children))
                    }
                </select>
            </label>
            </div>
            <div className="pivot-label-select">
            <label>
                Labels to display in the columns :
                <select value={selectedColLabel}
                    onChange={(e) => { 
                        setSelectedColLabel(e.target.value); 
                        setSortBy({ key: 'firstColumn', order: 'asc' })
                    }}
                >
                    {Object.keys(labelTypes)
                        .map((labelType) => (<option key={labelType} value={labelType}>{labelType}</option>))
                        .sort((a, b) => a.props.children.localeCompare(b.props.children))
                    }
                </select>
            </label>
            </div>
        </div>

        {/* Sentiment Controls Row */}
        <div className="sentiment-controls-row">
            {/* Sentiment Filter Controls for Row Label */}
            {isSentimentEnabled(selectedRowLabel) && (<SentimentControls 
                labelType={selectedRowLabel}
                sentimentStates={rowSentimentStates}
                handleSentimentChange={handleRowSentimentChange}
            />)}

            {/* Sentiment Filter Controls for Column Label */}
            {isSentimentEnabled(selectedColLabel) && (<SentimentControls 
                labelType={selectedColLabel}
                sentimentStates={colSentimentStates}
                handleSentimentChange={handleColSentimentChange}
            />)}
        </div>

        {/* Cross-analysis section */}
        <div className="pivot-label-selection">
            <h2 style={{fontSize: '14px', color: '#333', fontWeight: 500, flexBasis: '20%'}}>Cross-analysis of two attributes : </h2>
            <label style={{flexBasis: '20%'}}>
                <select style={{maxWidth: '300px'}} value={selectedFirstLabel} onChange={(e) => setSelectedFirstLabel(e.target.value)}>
                    <option value="">First choice</option>
                    {labels && Object.entries(labels)
                        .flatMap(([labelType, labelList]) => (labelList || []).map(label => (
                            <option key={`${labelType}-${label.name}`} value={label.name}>{label.name}</option>
                        )))
                        .sort((a, b) => a.props.children.localeCompare(b.props.children))
                    }
                </select>
            </label>
            <label style={{flexBasis: '20%'}}>
                <select style={{maxWidth: '300px'}} value={selectedSecondLabel} onChange={(e) => setSelectedSecondLabel(e.target.value)}>
                    <option value="">Second choice</option>
                    {labels && Object.entries(labels)
                        .flatMap(([labelType, labelList]) => (labelList || []).map(label => (
                            <option key={`${labelType}-${label.name}`} value={label.name}>{label.name}</option>
                        )))
                        .sort((a, b) => a.props.children.localeCompare(b.props.children))
                    }
                </select>
            </label>
            <button style={{
                backgroundColor: "#dc3545",
                padding: "6px 16px",
                border: "none",
                cursor: "pointer",
                fontSize: "0.9em",
                transition: "background-color 0.3s",
                flex: "1 1",
                textAlign: "center",
                color: "#fff",
                fontWeight: "bold",
                marginLeft: "10px",
                border: "1px solid #ddd",
                borderRadius: "5px",
                maxWidth: "100px",
            }} onClick={() => handleResetCrossLabelAnalysis()}>Reset</button>
        </div>
    </div>
  );
}

export default PivotLabelControls;
